module.exports = __webpack_public_path__ + "img/assignment-active.984fccde.png";